import { useState } from 'react'
import { ProductivityCard } from '../productivity-card/ProductivityCard'

export interface ProductivityVisitType {
  VisitTypeId: string
  Name: string
  ServiceName: string
  Duration: number | null
  DefaultDuration: number | null
  IsExemptFromNewPatientSpacing?: boolean
  MaxConsecutiveNewPatientVisits?: number | null
  IsNewPatientSpacingEnabled?: boolean
}

export type SaveProductivityArgs = {
  visitTypeId: string
  duration: number | null
  isExemptFromNewPatientSpacing: boolean
  maxConsecutiveNewPatientVisits: number | null
}

interface ProductivitySectionProps {
  visitTypes: ProductivityVisitType[]
  /** Resolves to whether the write landed; the editor stays open on `false`. */
  onSave: (args: SaveProductivityArgs) => Promise<boolean>
  onReset: (visitTypeId: string) => Promise<boolean>
  isSaving?: boolean
}

export function ProductivitySection({ visitTypes, onSave, onReset, isSaving }: ProductivitySectionProps) {
  const [editingId, setEditingId] = useState<string | null>(null)

  return (
    <div className='grid grid-cols-2 gap-sp-2'>
      {visitTypes.map((vt) => (
        <ProductivityCard
          key={`${vt.VisitTypeId}-${editingId === vt.VisitTypeId}`}
          visitTypeName={vt.Name}
          serviceName={vt.ServiceName}
          duration={vt.Duration}
          defaultDuration={vt.DefaultDuration}
          isExemptFromNewPatientSpacing={vt.IsExemptFromNewPatientSpacing ?? false}
          maxConsecutiveNewPatientVisits={vt.MaxConsecutiveNewPatientVisits ?? null}
          isNewPatientSpacingEnabled={vt.IsNewPatientSpacingEnabled ?? false}
          isEditing={editingId === vt.VisitTypeId}
          onEdit={() => setEditingId(vt.VisitTypeId)}
          onSave={(args) => {
            void onSave({ visitTypeId: vt.VisitTypeId, ...args }).then((saved) => {
              if (saved) setEditingId(null)
            })
          }}
          onCancel={() => setEditingId(null)}
          onReset={() => {
            void onReset(vt.VisitTypeId).then((reset) => {
              if (reset) setEditingId(null)
            })
          }}
          isSaving={isSaving ?? false}
        />
      ))}
    </div>
  )
}
